import styled, { css } from 'styled-components';

export const DivContents = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    gap: 48px;
    justify-content: center;
    min-height: 343px;
    padding: 0 32px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      gap: 16px;
      padding: 0 20px;
    }
    
    @media (max-width: ${theme.v2.breakpoints.lg}) {
      align-items: center;
      flex-direction: column;
      gap: 32px;
      white-space: normal;
    }
  `}
`;

export const DivImg = styled.div`
  ${({ theme }) => css`
    width: 50%;
    max-width: fit-content;
    display: flex;
    justify-content: flex-end;

    img {
      width: 100%;
      max-width: 573px;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      width: 100%;
      order: 0;
      justify-content: center;
      padding-top: 24px;
    }
  `}
`;

export const DivText = styled.div`
  ${({ theme }) => css`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    max-width: 460px;
    width: 50%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 100%;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      align-items: center;
      max-width: 573px;
      text-align: center;
      width: 100%;
    }
  `}
`;

export const Title = styled.p`
  ${({ theme }) => css`
      color: ${theme.v2.colors.brand.primaryBlue};
      font-family: ${theme.v2.font.family.primary};
      font-size: 20px;
      font-weight: ${theme.v2.font.weights.medium};
      line-height: 1.5;
      margin: 0px;

      @media (max-width: ${theme.v2.breakpoints.sm}) {
        font-size: ${theme.v2.font.sizes.sm2};
      }

      strong {
        font-weight: 500;
      }
  `}
`;

export const Subtitle = styled.p`
 ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryBlue};
    font-family: ${theme.v2.font.family.primary};
    font-size: 28px;
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 140%;
    margin: 0px 0px 20px 0px;
    max-width: 340px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.sm2};
      margin: 0 auto 16px auto;
    }

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      max-width: 100%;
    }
  `}
`;

export const DescriptionList = styled.ul`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
  `}
`;

export const DescriptionListItem = styled.li`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    padding: 0;
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 140%;
    list-style: none;
    text-align: left;
    svg {
      width: 24px;
      height: 24px;
      margin-top: 6px;
    }
  `}
`;

export const ButtonWrapper = styled.div`
 ${({ theme }) => css`
    display: flex;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      order: 2;
      width: 100%;
      max-width: 100%;
    }
 `}
`;

export const WrapperTitle = styled.div`
 ${({ theme }) => css`
  align-items: center;
  display: flex;
  gap: 6px;
  justify-content: center;
  margin: 0px 0px 16px 0px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 0 auto 16px auto;
    }
  `}
`;

export const TagAdapter = styled.div`  
  margin-left: 8px;
`;
